import React, { useState, useEffect } from "react";
import { dayjs } from "tools/timezone";
import { getThaiMonth } from "tools/util";
const localTimeZone = "Asia/Bangkok";

const Timer = () => {
  const [currentTime, setCurrentTime] = useState(dayjs());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(dayjs());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <p className="text-[20px] leading-[20px] mb-2">
        {`${dayjs(currentTime).format("DD")} ${getThaiMonth(parseInt(dayjs(currentTime).format("M")))} ${dayjs(currentTime).format("BBBB")}`} {dayjs(currentTime).format("HH:mm")} น. (GMT+7)
      </p>
      <p className="leading-[20px] lg:text-[20px] text-[16px]">({dayjs.tz(currentTime, localTimeZone).utc().format("UTC+0 MMM DD, YYYY HH:mm")})</p>
    </>
  );
};

export default Timer;
